import React, { useEffect, useRef, useState } from "react";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import Float from "./Float";
import Input from "./Input";

export default function Menu(props) {
    const {
        // menu = [],
        controller = "",
        bordered = false,
        route = "",
        columns = 1,
        keyName = "id",
        selected = {},
        setSelected = () => { },
        show_keys = false,
        callback = () => { },
        height = null, // NEW
        width = null,
        allow_keys = false,
        showCount = false,
        showSearch = false,
        searchValue = false,
        use_enter = false,
    } = props;

    const [search, setSearch] = useState("");
    const srch = useRef(null)
    const itemRefs = useRef({}); // NEW

    useEffect(() => {
        if (srch?.current) {
            srch.current.blur();
        }
    }, [selected])


    const menu = (search && showSearch)
        ? props.menu.filter(item => {
            const text = String(item?.[(searchValue) ? "value" : "text"] ?? "");
            return text.toLowerCase().includes(search.toLowerCase());
        })
        : props.menu;



    function rearrangeArray(arr) {
        if (columns === 1 || !arr.length > 1) return arr;
        const mid = Math.ceil(menu.length / 2);
        const left = menu.slice(0, mid);
        const right = menu.slice(mid);
        let _ret = [];
        for (let i = 0; i < mid; i++) {
            _ret.push(left[i]);
            if (i === mid - 1 && right.length === mid) {
                _ret.push(right[i]);
            } else {
                _ret.push(right[i]);
            }
        }
        return _ret;
    }

    const next = () => {
        let currentIndex = menu.findIndex(item => item?.[keyName] === selected);
        if (currentIndex !== -1) {
            currentIndex = (currentIndex + 1) % menu.length;
            setSelected(menu[currentIndex][keyName]);
        }
    };

    const prev = () => {
        let currentIndex = menu.findIndex(item => item?.[keyName] === selected);
        if (currentIndex !== -1) {
            currentIndex = (currentIndex - 1 + menu.length) % menu.length;
            setSelected(menu[currentIndex][keyName]);
        }
    };

    useEffect(() => {
        const actions = [

            { key: KBD.ARROW_DOWN, action: () => next() },
            { key: KBD.ARROW_UP, action: () => prev() },
            // { key: KBD.TAB, action: () => next() },
            // { key: KBD.SHIFT_TAB, action: () => prev() },
        ];

        if (use_enter) {
            actions.push({
                key: KBD.ENTER,
                action: () => {
                    const item = menu.find(item => item?.[keyName] === selected);
                    if (item && !item.disabled) {
                        callback(item);
                    }
                }
            });
        }


        // obv you can't have text search filter and letter selectors
        if (showSearch) {

            actions.push(
                {
                    key: KBD.ANY, text: "Total", action: (e) => {




                        if (e.key === KBD.ARROW_DOWN.key) {
                            next();
                            return;
                        }


                        if (e.key === KBD.ARROW_UP.key) {
                            prev();
                            return;
                        }

                        if (e.key === "Backspace" && search.length > 0) {

                            srch?.current.focus();
                            setSearch(search.slice(0, -1));
                            return;
                        }
                        const regex = /^[a-z0-9 ]$/i;
                        if (regex.test(e.key) && e.key.length === 1) {
                            srch?.current.focus();
                            setSearch(search + e.key);
                        }

                    }
                })

        }

        if (allow_keys) {
            menu.map(item => {
                actions.push({ key: item?.key, action: item?.action });
            })
        }

        const cleanup = listen(controller, route, actions);

        return cleanup;
    }, [selected, menu]);

    // Scroll selected item into view
    useEffect(() => {
        const ref = itemRefs.current?.[selected];
        if (ref && ref.scrollIntoView) {
            ref.scrollIntoView({ behavior: "smooth", block: "nearest" });
        }
    }, [selected]);


    useEffect(() => {
        if (!menu.length) return;
        const exists = menu.some(item => item?.[keyName] === selected);
        if (!exists) {
            setSelected(menu[0]?.[keyName]);
        }
    }, [menu, selected, keyName, setSelected]);



    const drawKey = (_key) => <div className="ui-menu-key">{_key?.label}</div>;

    const drawItem = (item, index) => {
        const itemId = item?.[keyName];

        const { disabled = false } = item;

        let _class = (itemId === selected) ? "ui-menu-row-selected" : "ui-menu-row";
        if (disabled) {
            _class += " beta";
        }

        return (
            <div

                key={index}
                ref={(el) => itemRefs.current[itemId] = el}
                onClick={() => {
                    setSelected(item?.[keyName]);
                    if (disabled) {
                        return;
                    }
                    callback(item)
                }}
                className={_class}
            >
                <Float stretch>
                    {show_keys && drawKey(item?.key)}
                    <div style={{ "width": (width) ? width + "px" : "100%" }} className="ui-menu-item"><Float><div style={{ "opacity": (item?.checked) ? ".7" : "1" }}>{(item?.checked && <>✓ </>)}{item.text}</div>{(showCount && <div className="ui-count">{item.count}</div>)}</Float></div>
                </Float>
            </div>
        );
    };

    return (
        <>
            {showSearch && <Input ref={srch} placeholder="Search..." onClick={() => setSelected()} controlled style={{ "textAlign": "left", "paddingLeft": "5px", "height": "25px", "width": "calc(100%)" }} cell edit={true} value={search} />}
            <div
                className={(bordered ? "ui-menu bordered grid" : "ui-menu")}
                style={{
                    gridTemplateColumns: `repeat(${columns}, 1fr)`,
                    ...(height ? { maxHeight: height, overflowY: 'auto' } : {}),
                }}
            >
                {rearrangeArray(menu).map((item, index) => drawItem(item, index))}
            </div>
        </>
    );
}
